<template>
  <div class="anchor-snippet">
    <div class="form-group">
      <label class="form-control-label">Line Label</label>
      <select v-model="selectedLineId" class="form-control form-control-sm">
        <option value="" disabled>Choose a connection to change</option>
        <option v-for="line in currentElement.relatedLines" :key="line.id" :value="line.id">{{ line.label }} - {{ line.targetLabel }}</option>
      </select>
    </div>
    
    <div class="form-group">
      <label class="form-control-label">Choose line color:</label>
      <ul class="color-pallete">
        <li v-for="(value, key, index) in colors" :key="index" class="pallete-item">
          <div @click="updateLineColor(key)" :style="{ background: value }"></div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { formBase } from './mixins'
import { mapState, mapMutations } from 'vuex'

export default {
  mixins: [formBase],
  computed: {
    ...mapState('diagramBuilder', [
      'currentElement'
    ])
  },
  data() {
    return {
      selectedLineId: '',
      colors: {
        regular: 'hsla(219, 79%, 66%, 0.6)',
        danger: 'hsla(348, 91%, 59%, 0.6)',
        success: 'hsla(154, 64%, 49%, 0.6)',
        warning: 'hsla(11, 96%, 62%, 0.6)',
        info: 'hsla(189, 87%, 50%, 0.6)',
      },
      selectedColor: 'hsla(219, 79%, 66%, 0.6)',
    }
  }, 
  methods: {
    ...mapMutations('diagramBuilder', [
      'updateLine'
    ]),
    updateLineColor(key) {
      this.selectedColor = this.colors[key]

      if (this.selectedLineId) {
        let selectedLine = this.lines.find(line => line.id === this.selectedLineId)
        selectedLine.type.color = this.selectedColor
        this.updateLine(selectedLine)
        this.updateCounter()
      }
    },
  },
  watch: {
    color: {
      immediate: true,
      handler: 'updateLineColor'
    }
  }
}
</script>

<style lang="scss" scoped>
  .color-pallete{
    display: grid; 
    grid-template-columns: repeat(auto-fill, 30px);
    margin: 0;
    padding: 0;
    list-style: none;
    .pallete-item{ 
      div{
        height: 21px;
        width: 21px;
        border-radius: 4px;
        cursor: pointer;
      }
    }
  }
</style>